import { Button, Grid2, InputAdornment, Typography } from "@mui/material"
import moment from "moment"
import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import {
  GetLocationRegisterDocument,
  LocationRegisterType,
  useGetLocationRegisterSuspenseQuery,
  useOpenLocationRegisterMutation
} from "src/graphql/quark/quark.type"
import ROUTE_PATHS from "src/routes/route-path"
import { CenteredBox, PageLoader, Stack } from "src/shared/components"
import OutlinedInput from "src/shared/components/outlined-input"
import { setBreadcrumbItem } from "src/shared/store/slices/breadcrumbs-slice"
import { useTypedDispatch, useTypedSelector } from "src/shared/store/store"
import Denomination from "../../components/Denomination"
import { usePermission } from "src/shared/hooks/usePermission"
import AccessDenied from "src/shared/container/access-denied"

const OpenRegister = () => {
  const { hasPermission } = usePermission()
  const { registerId } = useParams()
  const dispatch = useTypedDispatch()
  const auth = useTypedSelector((state) => state.authentication)
  const navigate = useNavigate()
  const [openingAmount, setOpeningAmount] = useState<null | number>(0)
  const { data: registerResp } = useGetLocationRegisterSuspenseQuery({
    variables: { getLocationRegisterId: registerId as string, locationId: auth.currentWhLoc?.id as string }
  })
  const register = registerResp?.getLocationRegister
  useEffect(() => {
    if (register?.id) dispatch(setBreadcrumbItem({ id: registerId as string, label: register.name }))
  }, [register])

  const [openRegister, { loading: isOpeningRegister }] = useOpenLocationRegisterMutation({
    refetchQueries: [
      {
        query: GetLocationRegisterDocument,
        variables: { getLocationRegisterId: registerId as string, locationId: auth?.currentWhLoc?.id as string }
      }
    ]
  })

  //   if (register === undefined) return <></>
  //   if (register.session?.status !== "OPENED")
  //     return (
  //       <CenteredBox height={"100%"}>
  //         <Typography>Register is already closed</Typography>
  //         <Button variant="outlined" size="small" sx={{ mt: 1 }} onClick={() => navigate(ROUTE_PATHS.REGISTER.BASE)}>
  //           Go Back
  //         </Button>
  //       </CenteredBox>
  //     )

  const handleOpeningRegister = async () => {
    const resp = await openRegister({
      variables: {
        registerId: register?.id as string,
        createLocationRegisterSessionDto: {
          openingAmount: openingAmount ?? 0
        }
      }
    })
    if (resp.data?.openLocationRegister?.id) {
      toast.success(`Register: ${register?.name} is opened successfully.`)
      navigate(ROUTE_PATHS.POS.BASE(auth?.currentWhLoc?.id as string, register?.id as string))
    }
  }

  // SalesRegister means it is a cash register
  if (register?.type === LocationRegisterType.SalesRegister && !hasPermission("sales-orders:pos:open-cash-register"))
    return <AccessDenied />

  return (
    <Stack sx={{ p: { xs: 2, lg: 3 } }}>
      <PageLoader isLoading={isOpeningRegister} />
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 6 }}>
          <Typography variant="h3">{register?.name}</Typography>
          <Typography variant="body2">{register?.type?.replace("_", " ")?.toLowerCase()}</Typography>

          <Stack mt={2}>
            <Denomination currency={auth?.tenant?.currency as string} />
          </Stack>
        </Grid2>
        <Grid2 size={{ xs: 6 }} sx={{ pt: 2 }}>
          <Typography variant="body1" textAlign={"center"}>
            <strong>Last Closed At:</strong>{" "}
            {register?.lastClosedAt
              ? moment(register?.lastClosedAt).format("hh:mm A - DD MMMM YYYY")
              : register?.lastOpenedAt
                ? ""
                : "Not open yet"}
          </Typography>

          {/* <BorderStack variant="columnCenter" sx={{ mt: { xs: 2, md: 10, lg: 20 } }}>
            <Typography variant="body1" textAlign={"center"}>
              <Link to="#">Click here</Link> to review and print the last closure summary. For older register summaries
              go to Reports &gt; Register &gt; Shift Report.
            </Typography>
            <Button variant="outlined" disabled sx={{ fontSize: (theme) => theme.typography.h3.fontSize, mt: 1 }}>
              OPEN REGISTER
            </Button>
          </BorderStack> */}
          <CenteredBox height={"100%"} sx={{ px: 2 }}>
            <OutlinedInput
              onChange={(e) => setOpeningAmount(e.target.value ? Number(e.target.value) : null)}
              value={openingAmount}
              fullWidth
              sx={{ mt: 2, fontSize: (theme) => theme.typography.h3.fontSize }}
              placeholder="Opening Amount"
              endAdornment={
                <InputAdornment sx={{ mr: -1.5 }} position="end">
                  <Button variant="contained" sx={{ height: "100%" }} size="small" onClick={handleOpeningRegister}>
                    OPEN
                  </Button>
                </InputAdornment>
              }
            />
          </CenteredBox>
        </Grid2>
      </Grid2>
    </Stack>
  )
}

export default OpenRegister
